import React from 'react'
import { Button, Input, InputBasic, Loader } from 'bzx-common/src/ui-framework'
import StatsVM from '../StatsVM'
import { observer } from 'mobx-react'
import { ReactComponent as ArrowPagination } from 'bzx-common/src/assets/images/fulcrum/icon_pagination.svg'
import EventInfo from 'shared-components/EventInfo'

const loader = (
  <div className="flex-center">
    <Loader quantityDots={3} sizeDots="small" />
  </div>
)

export function Activity({ vm }: { vm: StatsVM }) {
  const { latestProtocolEvents, selectedUserEvents } = vm.statsStore
  const { devMode } = vm.rootStore.settings
  const showLoader = selectedUserEvents.pending || latestProtocolEvents.pending
  return (
    <div className={`event-info ${devMode ? 'dev-mode' : ''}`}>
      <div className="flex-col-center panel--simple md-padded-2">
        <h3 className="txt-title">Latest activity across blockchains</h3>
        {latestProtocolEvents.loaded && (
          <div className="event-info__input ui-grid margin-bottom-1">
            <Input
              id="search-user"
              icon="search"
              placeholder="Filter by user address"
              onChange={vm.findByUser}
              value={vm.searchUser}
              onChangeEmit="value"
            />
            <div className="flex-center event-info__all-chains">
              <InputBasic
                id="show-all"
                type="checkbox"
                onChange={vm.showAllActivity}
                value={vm.allActivity}
              />
              <label className="margin-h-1ch txt-alternate" htmlFor="show-all">
                Get all chains activity
              </label>
            </div>
          </div>
        )}

        {showLoader ? (
          loader
        ) : (
          <>
            {latestProtocolEvents.error && (
              <p className="txt-warning padded-1">
                The latest protocol events could not be fetched.
              </p>
            )}
            <div className="event-info__grid">
              {vm.latestActivity.map((info, i) => (
                <EventInfo info={info} devMode={devMode} key={info.txHash + i} />
              ))}
            </div>
            {vm.quantityGrids > 1 && (
              <div className="pagination">
                <div
                  className={`prev ${vm.numberPagination === 0 ? `disabled` : ``}`}
                  onClick={vm.prevPagination}>
                  <ArrowPagination />
                </div>

                {vm.paginations.map((pagination) => (
                  <Button
                    size={'narrow'}
                    key={'pagination' + pagination}
                    variant="invisible"
                    name="numberPagination"
                    value={pagination}
                    onClick={vm.set}
                    onClickEmit="name-value">
                    <span
                      className={`padded-h-1 ${
                        pagination !== vm.numberPagination ? 'txt-muted' : 'txt-title'
                      }`}>
                      {++pagination}
                    </span>
                  </Button>
                ))}

                <div
                  className={`next ${vm.isLastEventsPagination ? `disabled` : ``}`}
                  onClick={vm.nextPagination}>
                  <ArrowPagination />
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  )
}

export default observer(Activity)
